import {Resource} from 'simpli-web-sdk'

export class MotoristaJornada extends Resource {
  idMotoristaJornadaPk: number = 0
  tempoInicioEmMinutos: number | null = null
  tempoFimEmMinutos: number | null = null
  segunda: boolean = false
  terca: boolean = false
  quarta: boolean = false
  quinta: boolean = false
  sexta: boolean = false
  sabado: boolean = false
  domingo: boolean = false
  ativo: boolean = true
  rangeCepInicial: string | null = null
  rangeCepFinal: string | null = null

  horaInicio: string | null = null
  horaFim: string | null = null

  get $id() {
    return this.idMotoristaJornadaPk
  }
  set $id(val) {
    this.idMotoristaJornadaPk = val
  }
}
